class ProductionPipe {
  constructor({ x = 0, y = 0, scene } = {}) {
    this.x = x;
    this.y = y;
    this.z = 3;

    this.spriteName = 'pipeEnd';

    this.frameHeight = 5;
    this.frameWidth = 9;

    this.width = this.frameWidth * 3;
    this.height = this.frameHeight * 3;

    this.x = scene.mainCanvas.width / 2 - this.width;
    this.y = -scene.mainCanvas.height / 2 + this.height / 2;

    this.frame = 0;

    this.loopProgress = 0;

    this.rubbishes = [];
    this.rubbishIndex = 0;

    this.active = true;
  }

  update(scene) {
    if (this.active) {
      this.loopProgress += 1;

      if (this.loopProgress > 10) {
        this.frame += 1;

        this.loopProgress = 0;

        if (this.frame > 4) {
          this.rubbishes.push(this.makeRubbish());

          this.frame = 0;
        }
      }
    } else {
      this.frame = 0;
    }
  }

  makeRubbish() {
    return {
      x: this.x - this.width / 4 + this.width / 2 * Math.random(),
      y: this.y,
      width: 5,
      height: 5,
      color: '#fff',
    };
  }

  render(canvas) {
    this.rubbishes.forEach((rubbish) => {
      rubbish.y += 0.9;

      canvas.drawCenteredRect(rubbish);
    });

    canvas.drawThing(this, this.frame);
  }
}

export default ProductionPipe;
